import React from 'react';

import { ReactComponent as Announcement } from './icons/announcement.svg';
import { ReactComponent as Calendar } from './icons/calendar.svg';
import { ReactComponent as Edit } from './icons/edit.svg';
import { Skeleton } from '@welbe/web-design-system';

import {
	Container,
	Title,
	Subtitle,
	ContainerDescription,
	Text,
	IconSkeleton,
	ContainerIcon,
} from './Card.styles';

interface CardProps {
	title?: string;
	companyName?: string;
	date?: string;
	iconType?: string;
	onClick?: () => void;
	disabled?: boolean;
	loading?: boolean;
	animation?: boolean;
}

export const Card = ({
	title,
	companyName,
	date,
	iconType,
	onClick,
	disabled,
	loading,
	animation = true,
}: CardProps): JSX.Element => {
	const Icon = iconType === 'calendar' ? Calendar : Edit;

	return (
		<Container
			data-testid="card"
			onClick={disabled ? () => null : onClick}
			disabled={disabled}
			loading={loading}
			animation={animation}
		>
			<ContainerIcon loading={loading}>
				<Announcement />
			</ContainerIcon>
			<Title loading={loading}>
				{loading ? <Skeleton animation={animation} /> : title}
			</Title>
			<Subtitle>
				{loading ? (
					<Skeleton animation={animation} height="16px" width="90%" />
				) : (
					companyName
				)}
			</Subtitle>
			<ContainerDescription>
				{loading ? (
					<>
						<Skeleton animation={animation} height="16px" width="80%" />
						<IconSkeleton />
					</>
				) : (
					<>
						{date && <Text>{`Campaña creada el ${date}`}</Text>}
						{Icon && <Icon />}
					</>
				)}
			</ContainerDescription>
		</Container>
	);
};

export default Card;
